export enum CaseEventType {
  CaseDraftCreated = 'CaseDraftCreated',
  CaseTxCenterDraftCreated = 'CaseTxCenterDraftCreated',
  CaseDetailsUpdated = 'CaseDetailsUpdated',
  CaseStatusUpdated = 'CaseStatusUpdated',
  CustomerCaseStatusUpdated = 'CustomerCaseStatusUpdated',
  CaseResourceReserved = 'CaseResourceReserved',
  CaseResourceReleased = 'CaseResourceReleased',
  CaseResourceAssigned = 'CaseResourceAssigned',
  CaseResourceUnassigned = 'CaseResourceUnassigned',
  CaseResourceInvitationAccepted = 'CaseResourceInvitationAccepted',
  CaseNoteAdded = 'CaseNoteAdded',
  CaseNoteRemoved = 'CaseNoteRemoved',
  CaseNoteUpdated = 'CaseNoteUpdated',
  CaseReviewUpdated = 'CaseReviewUpdated',

  CaseQuoteCommentSet = 'CaseQuoteCommentSet',
  CaseQuoteCreated = 'CaseQuoteCreated',
  CaseQuoteRejectedInternally = 'CaseQuoteRejectedInternally',
  CaseQuoteApprovedInternally = 'CaseQuoteApprovedInternally',
  CaseQuoteRecalled = 'CaseQuoteRecalled',
  CaseQuoteSentToTxCenter = 'CaseQuoteSentToTxCenter',
  CaseQuoteRejectedByTxCenter = 'CaseQuoteRejectedByTxCenter',
  CaseQuoteApprovedByTxCenter = 'CaseQuoteApprovedByTxCenter',
  CaseQuoteApprovedTxCenterProvider = 'CaseQuoteApprovedTxCenterProvider',

  BenchmarkSet = 'BenchmarkSet',

  CustomerFeedbackAdded = 'CustomerFeedbackAdded', // The related flow is not implemented yet.
  SetClinicalData = 'SetClinicalData',
  OrganAcceptanceCriteriaUpdated = 'OrganAcceptanceCriteriaUpdated',
  CustomRouteInitiated = 'CustomRouteInitiated', // [Obsolete]
  RoutePlanningStatusUpdated = 'RoutePlanningStatusUpdated',
  CaseResourceLogisticsStatusUpdated = 'CaseResourceLogisticsStatusUpdated',

  CaseRouteInitiated = 'CaseRouteInitiated',
  CaseDeclined = 'CaseDeclined',
  ServiceDeclined = 'ServiceDeclined',
  AttachFiles = 'AttachFiles',
  DetachFile = 'DetachFile',
  OpoContactsAssigned = 'OpoContactsAssigned',
  OpoContactIsPrimaryChanged = 'OpoContactIsPrimaryChanged',
  OpoContactsUnassigned = 'OpoContactsUnassigned',
  CaseResourceStartTimeEstablished = 'CaseResourceStartTimeEstablished',
  ReAllocatedCaseCreated = 'ReAllocatedCaseCreated',
  ReAllocatedCaseUpdated = 'ReAllocatedCaseUpdated',
  ReAllocatedCaseRemoved = 'ReAllocatedCaseRemoved',
  CaseLinkAdded = 'CaseLinkAdded',
  CaseLinkUpdated = 'CaseLinkUpdated',
  CaseLinkRemoved = 'CaseLinkRemoved',
  RequestOrganApproval = 'RequestOrganApproval',
  OrganApproved = 'OrganApproved',
  OrganDeclined = 'OrganDeclined',
  CreateSurgeonCaseSummary = 'CreateSurgeonCaseSummary',
  CaseInvoiceCreated = 'CaseInvoiceCreated',
  LightsSirensSupportChanged = 'LightsSirensSupportChanged',
  EtaUpdated = 'EtaUpdated',

  LogisticsCreated = 'LogisticsCreated',
}

export enum CaseRouteEventType {
  RouteChanged = 'RouteChanged',
}

export enum CaseGroundTripEventType {
  GroundTripUpdated = 'GroundTripUpdated',
}

export enum CaseGroupEventType {
  JoinCaseGroup = 'JoinCaseGroup',
  LeaveCaseGroup = 'LeaveCaseGroup',
  JoinCaseGroups = 'JoinCaseGroups',
  LeaveCaseGroups = 'LeaveCaseGroups',
}

export type WsCaseRouteEventMessageContent = {
  caseId: string;
  eventType: CaseRouteEventType.RouteChanged;
  routeId: string;
  logisticsId: string;
};

export type WsCaseGroundTripEventMessageContent = {
  caseId: string;
  eventType: CaseGroundTripEventType.GroundTripUpdated;
  groundTripId: string;
};

export type WsCaseEventMessageContent =
  | {
      caseId: string;
      eventType: CaseEventType;
    }
  | WsCaseRouteEventMessageContent
  | WsCaseGroundTripEventMessageContent;

export type CaseEventName = CaseEventType | `${string}:${CaseEventType}` | string;
